









import { RuleInterface } from '../../../types'
import { TranslateResult } from 'vue-i18n'
import Vue from 'vue'

export default Vue.extend({
  name: 'Rule',

  props: {
    rule: {
      required: true,
      type: Object as () => RuleInterface
    }
  },

  computed: {
    ruleDescription(): string {
      const descriptionNumbers: TranslateResult = this.$t(`correctNumbers[${this.rule.correctNumbers}]`) || ''
      let descriptionPositions: TranslateResult = ''

      if (this.rule.correctNumbers) {
        const allCorrectPositions = this.rule.correctPositions === this.rule.correctNumbers

        if (allCorrectPositions) {
          descriptionPositions = this.$t('correctPositions["all"]')
        } else {
          descriptionPositions = this.$t(`correctPositions[${this.rule.correctPositions}]`)
        }
      }

      return `${descriptionNumbers}${descriptionPositions}`
    }
  }
})
